module.exports = __webpack_public_path__ + "static/media/emptyList.9d6bb901.svg";